export default __webpack_public_path__ + "static/media/DtVmJx26TKEr37c9YMptilUs6yLUrwB0lw.53b265e4.woff2";